"use strict";

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

(function () {
  "use strict";

  var moduleName = "customIframe";
  var componentName = "customIframe";

  var bindings = {
    resolve: "<?",
    keyboard: "<?",
    source: "<?",
    title: "<?",
    heightCalculationMethod: "<?",
    minHeight: "<?",
    closeEvent: "<?",
    color: "<?",
    message: "<?",
    withFooter: "<?"
  };

  var templateUrl = "app/pages/customIframe/customIframe.html";

  var Controller = function () {
    /** @ngInject */
    function Controller($scope, $rootScope, $window, $timeout, $sce, PDF_URL, CustomListsService, UsersService) {
      _classCallCheck(this, Controller);

      console.log(moduleName + "/" + componentName);

      this.$scope = $scope;
      this.$rootScope = $rootScope;
      this.$window = $window;
      this.$timeout = $timeout;
      this.$sce = $sce;
      this.PDF_URL = PDF_URL;
      this.CustomListsService = CustomListsService;
      this.UsersService = UsersService;
    }

    _createClass(Controller, [{
      key: "close",
      value: function close() {
        console.log("$scope", this.$scope);

        if (this.$scope.$parent) {
          this.$scope.$parent.$dismiss();
        }
      }
    }, {
      key: "setEmails",
      value: function () {
        var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(emails) {
          var _this = this;

          var emailLines, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _loop, _iterator, _step, _ret;

          return regeneratorRuntime.wrap(function _callee$(_context2) {
            while (1) {
              switch (_context2.prev = _context2.next) {
                case 0:
                  emailLines = [];
                  _iteratorNormalCompletion = true;
                  _didIteratorError = false;
                  _iteratorError = undefined;
                  _context2.prev = 4;
                  _loop = /*#__PURE__*/regeneratorRuntime.mark(function _loop() {
                    var email;
                    return regeneratorRuntime.wrap(function _loop$(_context) {
                      while (1) {
                        switch (_context.prev = _context.next) {
                          case 0:
                            email = _step.value;

                            if (email.report) {
                              email.reports = [email.report];
                            }

                            if (!(!email.to && !email.cc && !email.phone && email.status !== "error" && !_this.isLvr // Not display bcc if not LVR
                            )) {
                              _context.next = 6;
                              break;
                            }

                            return _context.abrupt("return", "continue");

                          case 6:
                            if (!(!email.to && !email.cc && !email.phone && email.status !== "error" && !email.bcc)) {
                              _context.next = 8;
                              break;
                            }

                            return _context.abrupt("return", "continue");

                          case 8:
                            if (!email.triggeredBy) {
                              _context.next = 14;
                              break;
                            }

                            _context.next = 11;
                            return _this.UsersService.getNameById(email.triggeredBy.replace("$", ""));

                          case 11:
                            _context.t0 = _context.sent;
                            _context.next = 15;
                            break;

                          case 14:
                            _context.t0 = null;

                          case 15:
                            email.triggeredByName = _context.t0;


                            emailLines = [].concat(_toConsumableArray(emailLines), [{
                              titleBefore: "Le " + moment(email.creationDate).format("DD/MM/YYYY à HH:mm") + (email.triggeredByName ? " par " + email.triggeredByName : ""),
                              label: "Objet du mail",
                              value: email.subject
                            }, {
                              label: "Destinataires",
                              value: email.to ? email.to.split(",").map(function (to) {
                                return email.report && email.report.accepted && email.report.accepted.includes(to.replace(/ /g, "")) ? "" + to : email.report && email.report.not_delivered && email.report.not_delivered.includes(to.replace(/ /g, "")) ? to + " (non d\xE9livr\xE9)" : to + " (non envoy\xE9)";
                              }).join("<br/>") : ""
                            }, {
                              label: "En copie",
                              value: email.cc ? email.cc.split(",").map(function (cc) {
                                return email.report && email.report.accepted && email.report.accepted.includes(cc.replace(/ /g, "")) ? "" + cc : email.report && email.report.not_delivered && email.report.not_delivered.includes(cc.replace(/ /g, "")) ? cc + " (non d\xE9livr\xE9)" : cc + " (non envoy\xE9)";
                              }).join("<br/>") : ""
                            }, {
                              label: "En copie cachée",
                              value: email.bcc && _this.isLvr ? email.bcc.split(",").map(function (bcc) {
                                return email.report && email.report.accepted && email.report.accepted.includes(bcc.replace(/ /g, "")) ? "" + bcc : email.report && email.report.not_delivered && email.report.not_delivered.includes(bcc.replace(/ /g, "")) ? bcc + " (non d\xE9livr\xE9)" : bcc + " (non envoy\xE9)";
                              }).join("<br/>") : "",
                              hidden: !_this.isLvr
                            }, {
                              label: "Destinataires SMS",
                              value: email.phone && email.smsStatus === "send" ? email.phone : email.phone && email.smsStatus && email.smsStatus !== "send" ? email.phone + " (non envoy\xE9)" : ""
                            }, {
                              label: "Texte du SMS",
                              value: email.smsText ? email.smsText : ""
                            }, {
                              label: "Contenu",
                              value: email.html,
                              isHtml: true
                            }]);

                          case 17:
                          case "end":
                            return _context.stop();
                        }
                      }
                    }, _loop, _this);
                  });
                  _iterator = emails[Symbol.iterator]();

                case 7:
                  if (_iteratorNormalCompletion = (_step = _iterator.next()).done) {
                    _context2.next = 15;
                    break;
                  }

                  return _context2.delegateYield(_loop(), "t0", 9);

                case 9:
                  _ret = _context2.t0;

                  if (!(_ret === "continue")) {
                    _context2.next = 12;
                    break;
                  }

                  return _context2.abrupt("continue", 12);

                case 12:
                  _iteratorNormalCompletion = true;
                  _context2.next = 7;
                  break;

                case 15:
                  _context2.next = 21;
                  break;

                case 17:
                  _context2.prev = 17;
                  _context2.t1 = _context2["catch"](4);
                  _didIteratorError = true;
                  _iteratorError = _context2.t1;

                case 21:
                  _context2.prev = 21;
                  _context2.prev = 22;

                  if (!_iteratorNormalCompletion && _iterator.return) {
                    _iterator.return();
                  }

                case 24:
                  _context2.prev = 24;

                  if (!_didIteratorError) {
                    _context2.next = 27;
                    break;
                  }

                  throw _iteratorError;

                case 27:
                  return _context2.finish(24);

                case 28:
                  return _context2.finish(21);

                case 29:
                  return _context2.abrupt("return", emailLines);

                case 30:
                case "end":
                  return _context2.stop();
              }
            }
          }, _callee, this, [[4, 17, 21, 29], [22,, 24, 28]]);
        }));

        function setEmails(_x) {
          return _ref.apply(this, arguments);
        }

        return setEmails;
      }()
    }, {
      key: "setModifs",
      value: function () {
        var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(object) {
          var _this2 = this;

          var glossary, otherLists, modifs, _iteratorNormalCompletion2, _didIteratorError2, _iteratorError2, _iterator2, _step2, modif, historyUser, diffs, _iteratorNormalCompletion3, _didIteratorError3, _iteratorError3, _loop2, _iterator3, _step3, _ret2;

          return regeneratorRuntime.wrap(function _callee2$(_context4) {
            while (1) {
              switch (_context4.prev = _context4.next) {
                case 0:
                  _context4.next = 2;
                  return this.CustomListsService.getSelectArray("glossary");

                case 2:
                  glossary = _context4.sent;
                  otherLists = new Map();
                  modifs = [];

                  if (!object.history) {
                    _context4.next = 65;
                    break;
                  }

                  _iteratorNormalCompletion2 = true;
                  _didIteratorError2 = false;
                  _iteratorError2 = undefined;
                  _context4.prev = 9;
                  _iterator2 = object.history[Symbol.iterator]();

                case 11:
                  if (_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done) {
                    _context4.next = 50;
                    break;
                  }

                  modif = _step2.value;
                  _context4.next = 15;
                  return this.UsersService.getNameById(modif.userId);

                case 15:
                  historyUser = _context4.sent;
                  diffs = [];

                  if (!modif.diff) {
                    _context4.next = 46;
                    break;
                  }

                  _iteratorNormalCompletion3 = true;
                  _didIteratorError3 = false;
                  _iteratorError3 = undefined;
                  _context4.prev = 21;
                  _loop2 = /*#__PURE__*/regeneratorRuntime.mark(function _loop2() {
                    var diffKey, diffValue, _iteratorNormalCompletion4, _didIteratorError4, _iteratorError4, _iterator4, _step4, doc, _iteratorNormalCompletion5, _didIteratorError5, _iteratorError5, _iterator5, _step5, _doc, diffValueAsDate, _diffValueAsDate, glossaryItem, items, aValues, _iteratorNormalCompletion6, _didIteratorError6, _iteratorError6, _loop3, _iterator6, _step6, aItem, bValues, _iteratorNormalCompletion7, _didIteratorError7, _iteratorError7, _loop4, _iterator7, _step7, bItem;

                    return regeneratorRuntime.wrap(function _loop2$(_context3) {
                      while (1) {
                        switch (_context3.prev = _context3.next) {
                          case 0:
                            diffKey = _step3.value;

                            if (!["nbKilometersHistory", "nbKilometersHistoryPerGroup", "nbVehiclesHistory", "nbVehiclesHistoryPerGroup", "groups", "ignoreDamageMatch", "ignoreDriverMatch", "__v"].includes(diffKey)) {
                              _context3.next = 3;
                              break;
                            }

                            return _context3.abrupt("return", "continue");

                          case 3:
                            diffValue = void 0;

                            if (!(diffKey === "docs" || diffKey === "docsBilling")) {
                              _context3.next = 48;
                              break;
                            }

                            diffValue = { a: "", b: "" };

                            if (!modif.diff[diffKey]["a"]) {
                              _context3.next = 26;
                              break;
                            }

                            _iteratorNormalCompletion4 = true;
                            _didIteratorError4 = false;
                            _iteratorError4 = undefined;
                            _context3.prev = 10;

                            for (_iterator4 = modif.diff[diffKey]["a"][Symbol.iterator](); !(_iteratorNormalCompletion4 = (_step4 = _iterator4.next()).done); _iteratorNormalCompletion4 = true) {
                              doc = _step4.value;

                              if (doc && doc.name) {
                                if (diffValue["a"]) {
                                  diffValue["a"] += ", ";
                                }
                                diffValue["a"] += doc.name;
                              }
                            }
                            _context3.next = 18;
                            break;

                          case 14:
                            _context3.prev = 14;
                            _context3.t0 = _context3["catch"](10);
                            _didIteratorError4 = true;
                            _iteratorError4 = _context3.t0;

                          case 18:
                            _context3.prev = 18;
                            _context3.prev = 19;

                            if (!_iteratorNormalCompletion4 && _iterator4.return) {
                              _iterator4.return();
                            }

                          case 21:
                            _context3.prev = 21;

                            if (!_didIteratorError4) {
                              _context3.next = 24;
                              break;
                            }

                            throw _iteratorError4;

                          case 24:
                            return _context3.finish(21);

                          case 25:
                            return _context3.finish(18);

                          case 26:
                            if (!modif.diff[diffKey]["b"]) {
                              _context3.next = 46;
                              break;
                            }

                            _iteratorNormalCompletion5 = true;
                            _didIteratorError5 = false;
                            _iteratorError5 = undefined;
                            _context3.prev = 30;

                            for (_iterator5 = modif.diff[diffKey]["b"][Symbol.iterator](); !(_iteratorNormalCompletion5 = (_step5 = _iterator5.next()).done); _iteratorNormalCompletion5 = true) {
                              _doc = _step5.value;

                              if (_doc && _doc.name) {
                                if (diffValue["b"]) {
                                  diffValue["b"] += ", ";
                                }
                                diffValue["b"] += _doc.name;
                              }
                            }
                            _context3.next = 38;
                            break;

                          case 34:
                            _context3.prev = 34;
                            _context3.t1 = _context3["catch"](30);
                            _didIteratorError5 = true;
                            _iteratorError5 = _context3.t1;

                          case 38:
                            _context3.prev = 38;
                            _context3.prev = 39;

                            if (!_iteratorNormalCompletion5 && _iterator5.return) {
                              _iterator5.return();
                            }

                          case 41:
                            _context3.prev = 41;

                            if (!_didIteratorError5) {
                              _context3.next = 44;
                              break;
                            }

                            throw _iteratorError5;

                          case 44:
                            return _context3.finish(41);

                          case 45:
                            return _context3.finish(38);

                          case 46:
                            _context3.next = 51;
                            break;

                          case 48:
                            diffValue = modif.diff[diffKey];
                            if (typeof diffValue["a"] === "string" && isNaN(diffValue["a"])) {
                              diffValueAsDate = new Date(diffValue["a"]);

                              diffValueAsDate = diffValueAsDate.toLocaleString();
                              if (diffValueAsDate !== "Invalid Date" && diffValueAsDate !== "01/01/1970 01:00:00") {
                                diffValue["a"] = diffValueAsDate;
                              }
                            }
                            if (typeof diffValue["b"] === "string" && isNaN(diffValue["b"])) {
                              _diffValueAsDate = new Date(diffValue["b"]);

                              _diffValueAsDate = _diffValueAsDate.toLocaleString();
                              if (_diffValueAsDate !== "Invalid Date" && _diffValueAsDate !== "01/01/1970 01:00:00") {
                                diffValue["b"] = _diffValueAsDate;
                              }
                            }

                          case 51:
                            if (!(diffKey.endsWith("UserId") || diffKey.endsWith("userId") || diffKey.endsWith("ManagerId") || diffKey.endsWith("managerId") || diffKey.endsWith("DriverId") || diffKey.endsWith("driverId") || diffKey.endsWith("OperatorId") || diffKey.endsWith("operatorId"))) {
                              _context3.next = 59;
                              break;
                            }

                            _context3.next = 54;
                            return _this2.UsersService.getNameById(diffValue["a"]);

                          case 54:
                            _context3.t2 = _context3.sent;
                            _context3.next = 57;
                            return _this2.UsersService.getNameById(diffValue["b"]);

                          case 57:
                            _context3.t3 = _context3.sent;
                            diffValue = {
                              a: _context3.t2,
                              b: _context3.t3
                            };

                          case 59:
                            glossaryItem = glossary.find(function (item) {
                              return item.value === diffKey;
                            });

                            if (!(glossaryItem && glossaryItem.data)) {
                              _context3.next = 119;
                              break;
                            }

                            items = otherLists.get(glossaryItem.data);

                            if (items) {
                              _context3.next = 67;
                              break;
                            }

                            _context3.next = 65;
                            return _this2.CustomListsService.getSelectArray(glossaryItem.data);

                          case 65:
                            items = _context3.sent;

                            otherLists.set(glossaryItem.data, items);

                          case 67:
                            if (!Array.isArray(diffValue["a"])) {
                              _context3.next = 92;
                              break;
                            }

                            aValues = [];
                            _iteratorNormalCompletion6 = true;
                            _didIteratorError6 = false;
                            _iteratorError6 = undefined;
                            _context3.prev = 72;

                            _loop3 = function _loop3() {
                              var value = _step6.value;

                              var item = items.find(function (item) {
                                return item.value === value;
                              });
                              aValues.push(item ? item.name : value);
                            };

                            for (_iterator6 = diffValue["a"][Symbol.iterator](); !(_iteratorNormalCompletion6 = (_step6 = _iterator6.next()).done); _iteratorNormalCompletion6 = true) {
                              _loop3();
                            }
                            _context3.next = 81;
                            break;

                          case 77:
                            _context3.prev = 77;
                            _context3.t4 = _context3["catch"](72);
                            _didIteratorError6 = true;
                            _iteratorError6 = _context3.t4;

                          case 81:
                            _context3.prev = 81;
                            _context3.prev = 82;

                            if (!_iteratorNormalCompletion6 && _iterator6.return) {
                              _iterator6.return();
                            }

                          case 84:
                            _context3.prev = 84;

                            if (!_didIteratorError6) {
                              _context3.next = 87;
                              break;
                            }

                            throw _iteratorError6;

                          case 87:
                            return _context3.finish(84);

                          case 88:
                            return _context3.finish(81);

                          case 89:
                            diffValue["a"] = aValues.join(", ");
                            _context3.next = 93;
                            break;

                          case 92:
                            if ((typeof diffValue === "undefined" ? "undefined" : _typeof(diffValue)) === "object") {
                              aItem = items.find(function (item) {
                                return item.value === diffValue["a"];
                              });

                              diffValue["a"] = aItem ? aItem.name : diffValue["a"];
                            }

                          case 93:
                            if (!Array.isArray(diffValue["b"])) {
                              _context3.next = 118;
                              break;
                            }

                            bValues = [];
                            _iteratorNormalCompletion7 = true;
                            _didIteratorError7 = false;
                            _iteratorError7 = undefined;
                            _context3.prev = 98;

                            _loop4 = function _loop4() {
                              var value = _step7.value;

                              var item = items.find(function (item) {
                                return item.value === value;
                              });
                              bValues.push(item ? item.name : value);
                            };

                            for (_iterator7 = diffValue["b"][Symbol.iterator](); !(_iteratorNormalCompletion7 = (_step7 = _iterator7.next()).done); _iteratorNormalCompletion7 = true) {
                              _loop4();
                            }
                            _context3.next = 107;
                            break;

                          case 103:
                            _context3.prev = 103;
                            _context3.t5 = _context3["catch"](98);
                            _didIteratorError7 = true;
                            _iteratorError7 = _context3.t5;

                          case 107:
                            _context3.prev = 107;
                            _context3.prev = 108;

                            if (!_iteratorNormalCompletion7 && _iterator7.return) {
                              _iterator7.return();
                            }

                          case 110:
                            _context3.prev = 110;

                            if (!_didIteratorError7) {
                              _context3.next = 113;
                              break;
                            }

                            throw _iteratorError7;

                          case 113:
                            return _context3.finish(110);

                          case 114:
                            return _context3.finish(107);

                          case 115:
                            diffValue["b"] = bValues.join(", ");
                            _context3.next = 119;
                            break;

                          case 118:
                            if ((typeof diffValue === "undefined" ? "undefined" : _typeof(diffValue)) === "object") {
                              bItem = items.find(function (item) {
                                return item.value === diffValue["b"];
                              });

                              diffValue["b"] = bItem ? bItem.name : diffValue["b"];
                            }

                          case 119:

                            if ((typeof diffValue === "undefined" ? "undefined" : _typeof(diffValue)) === "object" && (typeof diffValue["a"] === "undefined" || diffValue["a"] === "undefined" || diffValue["a"] === "" || diffValue["a"] === null || diffValue["a"] === "null")) {
                              diffValue["a"] = "vide";
                            }

                            if ((typeof diffValue === "undefined" ? "undefined" : _typeof(diffValue)) === "object" && (typeof diffValue["b"] === "undefined" || diffValue["b"] === "undefined" || diffValue["b"] === "" || diffValue["b"] === null || diffValue["b"] === "null")) {
                              diffValue["b"] = "vide";
                            }

                            if (glossaryItem) {
                              diffKey = glossaryItem.name;
                            }
                            diffs = [].concat(_toConsumableArray(diffs), [{ name: diffKey, value: diffValue }]);

                          case 123:
                          case "end":
                            return _context3.stop();
                        }
                      }
                    }, _loop2, _this2, [[10, 14, 18, 26], [19,, 21, 25], [30, 34, 38, 46], [39,, 41, 45], [72, 77, 81, 89], [82,, 84, 88], [98, 103, 107, 115], [108,, 110, 114]]);
                  });
                  _iterator3 = Object.keys(modif.diff)[Symbol.iterator]();

                case 24:
                  if (_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done) {
                    _context4.next = 32;
                    break;
                  }

                  return _context4.delegateYield(_loop2(), "t0", 26);

                case 26:
                  _ret2 = _context4.t0;

                  if (!(_ret2 === "continue")) {
                    _context4.next = 29;
                    break;
                  }

                  return _context4.abrupt("continue", 29);

                case 29:
                  _iteratorNormalCompletion3 = true;
                  _context4.next = 24;
                  break;

                case 32:
                  _context4.next = 38;
                  break;

                case 34:
                  _context4.prev = 34;
                  _context4.t1 = _context4["catch"](21);
                  _didIteratorError3 = true;
                  _iteratorError3 = _context4.t1;

                case 38:
                  _context4.prev = 38;
                  _context4.prev = 39;

                  if (!_iteratorNormalCompletion3 && _iterator3.return) {
                    _iterator3.return();
                  }

                case 41:
                  _context4.prev = 41;

                  if (!_didIteratorError3) {
                    _context4.next = 44;
                    break;
                  }

                  throw _iteratorError3;

                case 44:
                  return _context4.finish(41);

                case 45:
                  return _context4.finish(38);

                case 46:
                  modifs = [].concat(_toConsumableArray(modifs), [{ date: modif.date, userName: historyUser, diffs: diffs }]);

                case 47:
                  _iteratorNormalCompletion2 = true;
                  _context4.next = 11;
                  break;

                case 50:
                  _context4.next = 56;
                  break;

                case 52:
                  _context4.prev = 52;
                  _context4.t2 = _context4["catch"](9);
                  _didIteratorError2 = true;
                  _iteratorError2 = _context4.t2;

                case 56:
                  _context4.prev = 56;
                  _context4.prev = 57;

                  if (!_iteratorNormalCompletion2 && _iterator2.return) {
                    _iterator2.return();
                  }

                case 59:
                  _context4.prev = 59;

                  if (!_didIteratorError2) {
                    _context4.next = 62;
                    break;
                  }

                  throw _iteratorError2;

                case 62:
                  return _context4.finish(59);

                case 63:
                  return _context4.finish(56);

                case 64:
                  modifs.reverse();

                case 65:
                  _context4.t3 = modifs;
                  _context4.t4 = object.creationDate || object.importDate;
                  _context4.next = 69;
                  return this.UsersService.getNameById(object.creationUserId);

                case 69:
                  _context4.t5 = _context4.sent;
                  _context4.t6 = [{
                    name: "Création",
                    value: ""
                  }];
                  _context4.t7 = {
                    date: _context4.t4,
                    userName: _context4.t5,
                    diffs: _context4.t6
                  };

                  _context4.t3.push.call(_context4.t3, _context4.t7);

                  return _context4.abrupt("return", modifs);

                case 74:
                case "end":
                  return _context4.stop();
              }
            }
          }, _callee2, this, [[9, 52, 56, 64], [21, 34, 38, 46], [39,, 41, 45], [57,, 59, 63]]);
        }));

        function setModifs(_x2) {
          return _ref2.apply(this, arguments);
        }

        return setModifs;
      }()
    }, {
      key: "$onInit",
      value: function () {
        var _ref3 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
          var emailLines, modifs, closeEvent, heightCalculationMethod, isOldIE, minHeight, iframe, that;
          return regeneratorRuntime.wrap(function _callee3$(_context5) {
            while (1) {
              switch (_context5.prev = _context5.next) {
                case 0:
                  this.keyboard = this.resolve && this.resolve.params && typeof this.resolve.params.keyboard === "boolean" ? this.resolve.params.keyboard : true;
                  if (this.resolve && this.resolve.params && this.resolve.params.source) {
                    this.source = this.$sce.trustAsResourceUrl(this.resolve.params.source);
                  }
                  if (this.resolve && this.resolve.params && this.resolve.params.color) {
                    this.color = this.resolve.params.color;
                  }
                  if (this.resolve && this.resolve.params && this.resolve.params.title) {
                    this.title = this.resolve.params.title;
                  }
                  if (this.resolve && this.resolve.params && this.resolve.params.withFooter) {
                    this.withFooter = this.resolve.params.withFooter;
                  }

                  if (!(this.resolve && this.resolve.params && this.resolve.params.message)) {
                    _context5.next = 24;
                    break;
                  }

                  this.message = this.resolve.params.message;

                  this.isAdmin = ["super-admin", "user-admin"].indexOf(this.$rootScope.$user.role) > -1 ? true : false;

                  this.isSuperAdmin = ["super-admin"].indexOf(this.$rootScope.$user.role) > -1 ? true : false;

                  this.isSuper = ["super-admin", "super-operator"].indexOf(this.$rootScope.$user.role) > -1 ? true : false;

                  this.isLvr = ["super-admin", "super-operator", "operator"].indexOf(this.$rootScope.$user.role) > -1 ? true : false;

                  if (!((this.isAdmin === true || this.isLvr === true) && this.message.emails && this.message.emails.length > 0)) {
                    _context5.next = 17;
                    break;
                  }

                  _context5.next = 14;
                  return this.setEmails(this.message.emails);

                case 14:
                  emailLines = _context5.sent;

                  this.message.filters.push("Historique des emails");
                  this.message.forms.push({
                    name: "Historique des emails",
                    filters: ["Historique des emails"],
                    lines: emailLines
                  });

                case 17:
                  if (!(this.isAdmin === true || this.isLvr === true)) {
                    _context5.next = 24;
                    break;
                  }

                  _context5.next = 20;
                  return this.setModifs(this.message.object);

                case 20:
                  modifs = _context5.sent;

                  this.message.filters.push("Modifications");
                  this.message.forms.push({
                    name: "Historique des modifications des plus récentes aux plus anciennes :",
                    filters: ["Modifications"],
                    lines: modifs.map(function (modif) {
                      return {
                        label: modif.userName + " le " + moment(modif.date).format("DD/MM/YYYY à HH:mm"),
                        value: modif.diffs.length > 0 ? modif.diffs.map(function (diff) {
                          return diff.value.a || diff.value.b // b = before, a = after
                          ? diff.name + " : " + JSON.stringify(diff.value.b) + " \u2192 " + JSON.stringify(diff.value.a) : diff.name !== "Création" ? diff.name + " : " + JSON.stringify(diff.value) : diff.name;
                        }).join("<br/>") : ""
                      };
                    })
                  });

                  if (this.message.actionHistories && this.message.actionHistories.length > 0) {
                    this.message.filters.push("Historique des accès");
                    this.message.forms.push({
                      name: "Historique des accès des 7 derniers jours :",
                      filters: ["Historique des accès"],
                      lines: this.message.actionHistories.map(function (access) {
                        return {
                          label: access.userName + " le " + moment(access.date).format("DD/MM/YYYY à HH:mm"),
                          value: access.action
                        };
                      })
                    });
                  }

                case 24:
                  closeEvent = void 0;

                  if (this.resolve && this.resolve.params && this.resolve.params.closeEvent) {
                    closeEvent = this.resolve.params.closeEvent;
                  }
                  heightCalculationMethod = void 0;

                  if (this.resolve && this.resolve.params && this.resolve.params.heightCalculationMethod) {
                    isOldIE = navigator.userAgent.indexOf("MSIE") !== -1; // Detect IE10 and below

                    heightCalculationMethod = isOldIE ? "max" : this.resolve.params.heightCalculationMethod;
                  }
                  minHeight = void 0;

                  if (this.resolve && this.resolve.params && this.resolve.params.minHeight) {
                    minHeight = this.resolve.params.minHeight;
                  }
                  // heightCalculationMethod = isOldIE ? 'max' : 'bodyOffset';
                  Notiflix.Loading.standard("Cliquez pour interrompre le chargement...");

                  iFrameResize({
                    log: true,
                    checkOrigin: false,
                    heightCalculationMethod: heightCalculationMethod,
                    minHeight: minHeight,
                    onResized: function onResized(_ref4) {
                      var iframe = _ref4.iframe,
                          height = _ref4.height,
                          width = _ref4.width,
                          type = _ref4.type;
                      return type === closeEvent ? Notiflix.Loading.remove() : console.log(type);
                    }
                  }, "#myIframe");

                  if (this.message) {
                    iframe = document.querySelector("#myIframe");

                    while (!iframe.contentWindow) {
                      iframe = iframe.contentDocument.querySelector("#myIframe");
                    }
                    that = this;

                    window.addEventListener("message", function (event) {
                      if (event.data === "loaded") {
                        iframe.contentWindow.postMessage(JSON.stringify(that.message), "*");
                        Notiflix.Loading.remove();
                      }
                    });
                  }

                case 33:
                case "end":
                  return _context5.stop();
              }
            }
          }, _callee3, this);
        }));

        function $onInit() {
          return _ref3.apply(this, arguments);
        }

        return $onInit;
      }()
    }]);

    return Controller;
  }();

  angular.module(moduleName).component(componentName, {
    templateUrl: templateUrl,
    bindings: bindings,
    //transclude: true,
    controller: Controller
  });
})();